import Hero from "../components/Hero";
import FunnyFacts from "../components/FunnyFacts";

function Home() {
  return (
    <>
      <Hero />
      <FunnyFacts />
    </>
  );
}

export default Home;